export const MATOMO_CUSTOM_DIMENSION_SLOT = {
  CUSTOMER_LEVEL: 1,
  TUNNEL: 2,
} as const;

export const MATOMO_CUSTOMER_LEVEL_VALUE = {
  N1: 'N1',
  N2: 'N2',
} as const;

export const MATOMO_TUNNEL_VALUE = {
  TYRE: 'tyre',
  WHEEL: 'wheel',
} as const;

export const MATOMO_FUNNEL_STEP = {
  SEARCH_SUBMITTED: 'Step1_SearchSubmitted',
  ADDED_TO_CART: 'Step2_AddedToCart',
  ORDER_CONFIRMED: 'OrderConfirmed',
} as const;

export const MATOMO_WCW_FUNNEL_STEP = {
  SEARCH_SUBMITTED: 'Wcw_Step1_SearchSubmitted',
  ADDED_TO_CART: 'Wcw_Step2_AddedToCart',
  ORDER_CONFIRMED: 'Wcw_OrderConfirmed',
} as const;

export const MATOMO_SEARCH_CATEGORY = {
  DIMENSION_MANUAL: 'dimension_manual',
  DIMENSION_QUICK: 'dimension_quick',
  EAN: 'ean',
  CAI: 'cai',
  REFERENCE: 'reference',
  UNKNOWN: 'unknown',
} as const;

let _suppressNextPageView = false;

export function suppressNextPageView(): void {
  _suppressNextPageView = true;
}

export function consumeSuppressPageView(): boolean {
  if (_suppressNextPageView) {
    _suppressNextPageView = false;
    return true;
  }
  return false;
}

export function trackEvent(
  category: string,
  action: string,
  name?: string,
  value?: number,
): void {
  const payload: Array<unknown> = ['trackEvent', category, action];
  if (name !== undefined) {
    payload.push(name);
    if (value !== undefined && Number.isFinite(value)) {
      payload.push(value);
    }
  }
  window._paq?.push(payload);
}

export function setCustomDimension(id: number, value: string): void {
  window._paq?.push(['setCustomDimension', id, value]);
}

export function deleteCustomDimension(id: number): void {
  window._paq?.push(['deleteCustomDimension', id]);
}

export function trackSiteSearch(
  keyword: string,
  category?: string | false,
  searchCount?: number | false,
): void {
  window._paq?.push([
    'trackSiteSearch',
    keyword,
    category ?? false,
    searchCount ?? false,
  ]);
}

export function addCartItem(
  sku: string,
  name?: string,
  category?: string,
  price?: number,
  quantity?: number,
): void {
  window._paq?.push([
    'addEcommerceItem',
    sku,
    name ?? '',
    category ?? '',
    price ?? 0,
    quantity ?? 1,
  ]);
}

export function removeCartItem(sku: string): void {
  window._paq?.push(['removeEcommerceItem', sku]);
}

export function clearCart(): void {
  window._paq?.push(['clearEcommerceCart']);
}

export function updateCartTotal(cartTotal: number): void {
  window._paq?.push(['trackEcommerceCartUpdate', cartTotal]);
}

export function trackOrder(
  orderId: string,
  grandTotal: number,
  subTotal?: number,
  tax?: number,
  shipping?: number,
  discount?: number,
): void {
  window._paq?.push([
    'trackEcommerceOrder',
    orderId,
    grandTotal,
    subTotal ?? 0,
    tax ?? 0,
    shipping ?? 0,
    discount ?? 0,
  ]);
}
